export default class Cursor {
    constructor(game) {
        this.game = game;
    }
    default() {
        this.set("grab")
    }
    grabbing() {
        this.set("grabbing")
    }
    hidden() {
        this.set("pointer")
    }
    set(inputStr) {
        this.game.canvas.style.cursor = inputStr;
    }
}